import React from 'react';

const MorseChart = () => {
  return (
    <table>
      <thead>
        <tr>
          <th>Alphabet</th>
          <th>Morse Code</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>A</td>
          <td>• ―</td>
        </tr>
        <tr>
          <td>B</td>
          <td>― • • •</td>
        </tr>
        <tr>
          <td>C</td>
          <td>― • ― • </td>
        </tr>
        <tr>
          <td>CH</td>
          <td>― ― ― ― </td>
        </tr>
        <tr>
          <td>D</td>
          <td>― • • </td>
        </tr>
        <tr>
          <td>E</td>
          <td>•</td>
        </tr>
        <tr>
          <td>F</td>
          <td>• • ― • </td>
        </tr>
        <tr>
          <td>G</td>
          <td>― ― • </td>
        </tr>
        <tr>
          <td>H</td>
          <td>• • • • </td>
        </tr>
        <tr>
          <td>I</td>
          <td>• • </td>
        </tr>
        <tr>
          <td>J</td>
          <td>• ― ― ― </td>
        </tr>
        <tr>
          <td>K</td>
          <td>― • ― </td>
        </tr>
        <tr>
          <td>L</td>
          <td>• ― • • </td>
        </tr>
        <tr>
          <td>M</td>
          <td>― ― </td>
        </tr>
        <tr>
          <td>N</td>
          <td>― • </td>
        </tr>
        <tr>
          <td>O</td>
          <td>― ― ― </td>
        </tr>
        <tr>
          <td>P</td>
          <td>• ― ― • </td>
        </tr>
        <tr>
          <td>Q</td>
          <td>― ― • ― </td>
        </tr>
        <tr>
          <td>R</td>
          <td>• ― • </td>
        </tr>
        <tr>
          <td>S</td>
          <td>• • • </td>
        </tr>
        <tr>
          <td>T</td>
          <td>― </td>
        </tr>
        <tr>
          <td>U</td>
          <td>• • ― </td>
        </tr>
        <tr>
          <td>V</td>
          <td>• • • ― </td>
        </tr>
        <tr>
          <td>W</td>
          <td>• ― ― </td>
        </tr>
        <tr>
          <td>X</td>
          <td>― • • ―  </td>
        </tr>
        <tr>
          <td>Y</td>
          <td>― • ― ― </td>
        </tr>
        <tr>
          <td>Z</td>
          <td>― ― • •</td>
        </tr>

      </tbody>
    </table>
  );
};

export {MorseChart};
